import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { interceptValueSet2j91wmwtts8v0 as interceptValueSet } from './utils.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { last1vo29oleiqj36 as last } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { AppState_getInstance1lcg5jamx8e1g as AppState_getInstance } from '../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { KeyCodes_instancevfnkc2xsbiba as KeyCodes_instance } from '../../../../kiteui-library/com/lightningkite/kiteui/models/KeyCode.commonHtml.mjs';
import { asReversed2y2qzr7vrqd5 as asReversed } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ReversedViews.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import { FocusSemantic_getInstance2hulmpskh8zvf as FocusSemantic_getInstance } from '../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { reactive2pl1t9wy5gll5 as reactive } from '../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function Cursor$index$lambda($this$interceptValueSet, set) {
  var tmp;
  if (set == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeUnless' call
    var tmp_0;
    if (!(set < 0)) {
      tmp_0 = set;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  $this$interceptValueSet.mam(tmp);
  return Unit_instance;
}
var CursorClass;
function Cursor() {
  if (CursorClass === VOID) {
    class $ {
      constructor(items, id) {
        this.vg2_1 = items;
        this.wg2_1 = id;
        var tmp = this;
        var tmp_0 = Signal().fak(null);
        tmp.xg2_1 = interceptValueSet(tmp_0, Cursor$index$lambda);
        var tmp_1 = this;
        tmp_1.yg2_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0_safe_receiver = $this$remember.baj(this.xg2_1);
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            var items = $this$remember.baj(this.vg2_1);
            var tmp_0;
            if (items.i1() || tmp0_safe_receiver < 0) {
              this.xg2_1.mam(null);
              tmp_0 = null;
            } else if (tmp0_safe_receiver > get_lastIndex(items)) {
              this.xg2_1.mam(get_lastIndex(items));
              tmp_0 = last(items);
            } else {
              tmp_0 = items.q1(tmp0_safe_receiver);
            }
            tmp = tmp_0;
          }
          return tmp;
        });
        var tmp_2 = this;
        tmp_2.zg2_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0_safe_receiver = $this$remember.baj(this.yg2_1);
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp = this.wg2_1(tmp0_safe_receiver);
          }
          return tmp;
        });
      }
      ag3(steps) {
        // Inline function 'kotlin.let' call
        var it = this.xg2_1.f2();
        if (it == null) {
          this.xg2_1.mam(steps - 1 | 0);
        } else {
          this.xg2_1.mam(it + steps | 0);
        }
      }
      bg3(steps) {
        // Inline function 'kotlin.let' call
        var tmp0 = this.xg2_1.f2();
        $l$block: {
          if (tmp0 == null) {
            break $l$block;
          } else {
            this.xg2_1.mam(tmp0 - steps | 0);
          }
        }
      }
      cg3() {
        this.ag3(1);
      }
      dg3() {
        this.bg3(1);
      }
    }
    initMetadataForClass($, 'Cursor');
    CursorClass = $;
  }
  return CursorClass;
}
function Cursor_0(items) {
  var tmp = remember(VOID, VOID, VOID, items);
  return new (Cursor())(tmp, Cursor$lambda);
}
function start($this) {
  if (!($this.fg3_1 == null) || $this.eg3_1.i1())
    return Unit_instance;
  var tmp = $this;
  var tmp_0 = AppState_getInstance();
  tmp.fg3_1 = tmp_0.sdo(CursorStack$start$lambda);
}
function stop($this) {
  var tmp0_safe_receiver = $this.fg3_1;
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver();
  $this.fg3_1 = null;
}
function CursorStack$start$lambda(it) {
  var tmp0_subject = it.ocy_1;
  var tmp;
  if (tmp0_subject === KeyCodes_instance.cax()) {
    tmp = true;
  } else if (tmp0_subject === KeyCodes_instance.dax()) {
    tmp = false;
  } else {
    return false;
  }
  var up = tmp;
  var _iterator__ex2g4s = asReversed(CursorStack_getInstance().eg3_1).m1();
  $l$loop: while (_iterator__ex2g4s.n1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.o1();
    var cursor = _destruct__k2r9zo.cf();
    var onlyWhen = _destruct__k2r9zo.df();
    if (!onlyWhen())
      continue $l$loop;
    if (up) {
      cursor.dg3();
    } else {
      cursor.cg3();
    }
    return true;
  }
  return false;
}
var CursorStackClass;
function CursorStack() {
  if (CursorStackClass === VOID) {
    class $ {
      constructor() {
        CursorStack_instance = this;
        this.eg3_1 = ArrayList().w();
        this.fg3_1 = null;
      }
      gg3(cursor, onlyWhen) {
        this.eg3_1.v(to(cursor, onlyWhen));
        start(this);
        return () => {
          var tmp0 = CursorStack_getInstance().eg3_1;
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.indexOfFirst' call
            var index = 0;
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var item = _iterator__ex2g4s.o1();
              if (item.af_1 === cursor) {
                tmp$ret$1 = index;
                break $l$block;
              }
              index = index + 1 | 0;
            }
            tmp$ret$1 = -1;
          }
          var idx = tmp$ret$1;
          var tmp;
          if (!(idx === -1)) {
            CursorStack_getInstance().eg3_1.z3(idx);
            var tmp_0;
            if (CursorStack_getInstance().eg3_1.i1()) {
              stop(CursorStack_getInstance());
              tmp_0 = Unit_instance;
            }
            tmp = tmp_0;
          }
          return Unit_instance;
        };
      }
    }
    initMetadataForObject($, 'CursorStack');
    CursorStackClass = $;
  }
  return CursorStackClass;
}
var CursorStack_instance;
function CursorStack_getInstance() {
  if (CursorStack_instance === VOID)
    new (CursorStack())();
  return CursorStack_instance;
}
function bindToArrowKeys(view, _this__u8e3s4) {
  var tmp = CursorStack_getInstance();
  // Inline function 'kotlin.also' call
  var this_0 = tmp.gg3(_this__u8e3s4, bindToArrowKeys$lambda);
  onRemove(view, this_0);
}
function focusedIfCursorSelected(_this__u8e3s4, cursor, id) {
  if (cursor == null)
    return Unit_instance;
  var oldTheme = _this__u8e3s4.ob6_1;
  reactive(_this__u8e3s4, ($this$reactive) => {
    var tmp;
    if (equals($this$reactive.baj(cursor.zg2_1), $this$reactive.baj(id))) {
      _this__u8e3s4.jba(oldTheme.ybe(FocusSemantic_getInstance()));
      _this__u8e3s4.nb9(null, null, true);
      tmp = Unit_instance;
    } else {
      _this__u8e3s4.jba(oldTheme);
      tmp = Unit_instance;
    }
    return Unit_instance;
  });
}
function focusedIfCursorSelected_0(_this__u8e3s4, cursor, item) {
  if (cursor == null)
    return Unit_instance;
  focusedIfCursorSelected(_this__u8e3s4, cursor, lens(item, cursor.wg2_1));
}
function Cursor$lambda(it) {
  return it.h40();
}
function bindToArrowKeys$lambda() {
  return true;
}
//region block: exports
export {
  Cursor_0 as Cursor37k0vceqk2231,
  bindToArrowKeys as bindToArrowKeys1daveb700wdu5,
  focusedIfCursorSelected_0 as focusedIfCursorSelected22hr3iuy5vsdy,
};
//endregion

//# sourceMappingURL=Cursor.mjs.map
